import { Navigation } from '@app/navigation/enums/navigation.enum';

export const contractSuccessRoute = '../contract-success';
export const meterReadingsRoute = '../meter-readings';
export const contactDetailsLeaverRoute = `/${Navigation.OTS}/${Navigation.LeaverDetails}`;
